import { Avatar } from 'components/Avatar/Avatar';
import { AvatarGroup } from 'components/Avatar/AvatarGroup';

import { useCmsReactionsContext } from './CmsReactionsContext';

export function CmsLatestReactionAvatars() {
  const { latestReactions } = useCmsReactionsContext();

  return latestReactions.length === 0 ? null : (
    <AvatarGroup $stacked data-qa-id="cms-latest-reaction-avatars">
      {latestReactions.map((reaction) => (
        <Avatar
          border="white"
          image={reaction.user.profile.image}
          name={reaction.user.profile.name}
          size="xs"
        />
      ))}
    </AvatarGroup>
  );
}
